'use strict';

/**
 * @ngdoc service
 * @name prepApp.Utils
 * @description
 * # Utils
 * Factory in the prepApp.
 */
angular.module('prepApp')
    .factory('Utils', function ($http, $document, $timeout) {
        return {
            savePDFFile: function (pdfURL, fileName) {
                $http.get(pdfURL)
            .then(function (data) {
                var file = new Blob([data.data], { type: 'application/octet-stream"' });
                var fileURL = URL.createObjectURL(file);

                var link = $document[0].createElement('a');
                link.href = fileURL;
                link.download = fileName;
                $document[0].body.appendChild(link);
                link.click();
                $timeout(function () {
                    $document[0].body.removeChild(link);
                    URL.revokeObjectURL(fileURL);
                }, 100);
            });
            }
        };
    });
